class Callbacks {
  static filterToFormHandler() {
    return function filterToForm(filter) {
      return { active: true }
    }
  }
  static formToFilterHandler() {
    return function formToFilter(values, extra, meta, state) {
      return values
    }
  }
}

export default Callbacks
